import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';
import { RootState } from '../store';
import { deleteDogGeofence, deleteGeofence } from '../slices/user';

export const getGeofences = createAsyncThunk('geofences/get', async (_, { getState }) => {
    const state = getState() as RootState;
    const { activeTeam } = state.team;

    const response = await axios.get('geofences', { params: { teamId: activeTeam ?? 0 } });

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const getAllGeofences = createAsyncThunk('geofences-all/get', async (_, { getState }) => {
    const state = getState() as RootState;
    const { teams, sharedTeams } = state.team;

    let teamsIds = '';
    let teamIds: number[] = [];
    let sharedTeamIds: number[] = [];

    if (Array.isArray(teams)) {
        teamIds = teams.filter((t) => t.id !== undefined).map((t) => t.id);
    }

    if (Array.isArray(sharedTeams)) {
        sharedTeamIds = sharedTeams.filter((t) => t.id !== undefined).map((t) => t.id);
    }

    const combinedIds = [...new Set([...teamIds, ...sharedTeamIds])];

    teamsIds = combinedIds.join(',');

    const response = await axios.get('geofences-all', { params: { teamsIds } });

    // console.log('getAllGeofences', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const getDogGeofences = createAsyncThunk('geofences/dogs/get', async () => {
    const response = await axios.get('geofences/dogs');

    // console.log('response', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const createTeamGeofence = createAsyncThunk('geofences/create/copy', async ({ body }: { body: FormData }) => {
    const response = await axios.post('geofences/create', body);

    // console.log('response', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const uploadGPXFile = createAsyncThunk('geofences/create/copy', async ({ file }: { file: File }) => {
    const formData = new FormData();
    formData.append('file', file, 'gpx.gpx');
    const response = await axios.post('upload/parse-gpx', formData);

    if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
        return response;
    } else {
        throw 'error';
    }
});

export const createGround = createAsyncThunk(
    'geofences/create/ground',
    async ({ body, path }: { body: FormData; path: string }) => {
        const response = await axios.post(path, body);

        return response;
    },
);

export const updateGround = createAsyncThunk(
    'geofences/update/ground',
    async ({ values, path }: { values: any; path: string }) => {
        const response = await axios.put(path, values);

        return response;
    },
);

export const deleteGeoFence = createAsyncThunk(
    'geofences/delete/',
    async ({ id }: { id: number }, { getState, dispatch }) => {
        const state = getState() as RootState;

        const mode = state.user.geofenceMode;

        const url = mode === 'geofence' ? `geofences/dog/${id}` : `geofences/${id}`;

        const response = await axios.delete(url);

        if (response.status === 200 && typeof response.data === 'object') {
            if (response.data.status === 200) {
                if (mode === 'geofence') {
                    dispatch(deleteDogGeofence(id));
                } else {
                    dispatch(deleteGeofence(id));
                }
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },
);
